<form [formGroup]="editWorkspaceForm" (ngSubmit)="onSubmit()">
    <div class="dialog-header"> 
        <h2 class="dialog-title">Edit Workspace: {{workspace.workspaceName}}</h2>   
        <button class="cancel-button" mat-button type="button" [disabled]="isSubmitting()" (click)="onCancel()">Cancel</button>
    </div>
    <div class="dialog-body">
        <mat-dialog-content class="dialog-form">
            <mat-form-field>
                <mat-label>Workspace Alias</mat-label>
                <input class="input" matInput maxlength="128" formControlName="workspaceAlias">
            </mat-form-field>
            @if (editWorkspaceForm.get('workspaceAlias')?.errors?.['pattern']) {
                <mat-error>Workspace alias must be empty or between 3 and 128 characters, cannot start or end with spaces, and cannot consist only of spaces.</mat-error>
            }
            <div class="toggle-container">
                <mat-slide-toggle formControlName="privateAccessToWorkspace"></mat-slide-toggle>
                <mat-label class="toggle-button-label"> Private Access to Workspace </mat-label>
            </div>
            @if (workspace.publicNetworkAccess === networkAccess.Enabled && this.editWorkspaceForm.get('privateAccessToWorkspace')?.value) {
                <div class="info-message">
                    <mat-icon>info</mat-icon>
                    <p class="info-text">
                        Enabling private access takes about 20 minutes to complete. The form will close once the operation begins (this may take a few minutes). Progress and completion status will be shown in the workspace table.
                        Please ensure all necessary preparations are complete before proceeding.
                    </p>
                </div>
            } @else if (workspace.publicNetworkAccess === networkAccess.Disabled) {
                <div class="info-message">
                    <mat-icon>info</mat-icon>
                    <p class="info-text">Private access cannot be reverted after enabling.</p>
                </div>
            }
            
            @if (submissionErrorMessage()) {
                <div class="error-message">{{submissionErrorMessage()}}</div>
            }
        </mat-dialog-content>     
    </div>
    <mat-dialog-actions class="dialog-footer">
        <button class="submit-button" mat-flat-button 
            color="primary"
            type="submit" 
            [disabled]="!editWorkspaceForm.valid || isSubmitting()"> 
            @if (!isSubmitting()) {
                Edit Workspace
            } @else {
                <div class="submission-message">
                    <div class="submit-loading-spinner"><app-loading-spinner [strokeWidth]="5"></app-loading-spinner></div>
                    <p>Updating Workspace...</p>
                </div>
            }   
        </button>
    </mat-dialog-actions>
</form>